import { MessageProps } from 'message/index.props'
export const message: MessageProps = {
  i18n: {
    changeLanguage: 'English',
    toUrl: '/en/index.html',
  },
  meta: {
    site_name: 'ウェスティン都ホテル京都｜グランドリニューアル - 特設サイト',
    description:
      '創業130年を迎えたウェスティン都ホテル京都。これまでに築いてきた歴史と伝統を受け継ぎながら、新しい時代にふさわしいラグジュアリーホテルとして、天然温泉を利用したスパ施設の新規オープンや京都の風情を取り入れた客室など、さらにご満足いただける空間をご提供いたします。',
    keywords:
      'ウェスティン都ホテル京都, ウェスティン都ホテル, ウェスティン, 都ホテル, 高級ホテル, ラグジュアリーホテル, 京都高級ホテル',
  },
  global: {
    language: {
      select: 'Language',
      japanese: '日本語',
      english: 'English',
    },
    detail: 'MORE',
    topic_path: {
      top: 'TOP',
    },
    message: 'メッセージ',
    spa: 'スパ',
    room: '客室',
    kasuien: '佳水園',
    restaurant: 'レストラン',
    other: 'その他',
    westinkyoto: {
      name: 'ウェスティン都ホテル京都',
      address: '〒605-0052 京都市東山区粟田口華頂町1(三条けあげ)',
      tel: 'TEL: 075-771-7111',
    },
    copyright:
      'Copyright © 2021 Kintetsu Miyako Hotels International, Inc. All Rights reserved.',
    to_top: 'ウェスティン都ホテル京都TOPへ',
    to_top_button: {
      url: 'https://www.miyakohotels.ne.jp/westinkyoto/index.html',
    },
  },
  top: {
    page_title: 'ウェスティン都ホテル京都｜グランドリニューアル - 特設サイト',
    catchcopy: '上質の極みへ 雅なひとときを',
    scroll: 'scroll',
    renewal: '',
    message: {
      headline: 'Message',
      title: 'ウェスティン都ホテル京都　2021年グランドリニューアル ',
      text:
        'ウェスティン都ホテル京都は、2020 年に創業 130 年を迎えるにあたり、これまでに築いてきた歴史と伝統を受け継ぎながら、さらにラグジュアリーなホテルを目指して、大規模リニューアル工事を実施してまいりました。<br>ホテル全体のリニューアルデザインコンセプトは気品ある女王「The Queen of Elegance(クイーンオブ エレガンス)」とし、国内外にその名を轟かせたいという想いを込め、新しい時代にふさわしい設えやサービスを加え、ラグジュアリー層にご満足いただけるホテルに完成いたしました。',
    },
    spa: {
      section_title: {
        headline: 'New',
        title: 'SPA「華頂」',
        num: '1',
      },
      contents: [
        {
          title: '優雅なここにしかない天然温泉の温浴施設',
          text:
            '天然温泉を利用したSPA「華頂（かちょう）」は、地元華頂山や琵琶湖疏水との調和を大切にし、ここにしかない温浴施設として設計しました。洗練された特徴的なアーチは、ホテルの歴史を想起させるとともに、疏水を代表する水路閣のモチーフとも一致し、その優雅さを大浴場であらわしています。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/information/spa_kacho/index.html',
          },
        },
      ],
    },
    room: {
      section_title: {
        headline: 'Renewal',
        title: '客室',
        num: '2',
      },
      contents: [
        {
          title:
            '京都・東山の自然をイメージした造りで今まで以上にゆったりとおくつろぎいただける空間を実現',
          text:
            '木の風合いを取り入れるなど京都・東山の自然をイメージした造りとし、インテリア等で曲線美や優美さなどの柔らかさを表現しています。東館は京都の夏の風物詩である「川床」をイメージしたカーペットや梅の花を模したスツールなど、日本らしさ、京都らしさを感じていただけるデザインを採用、落ち着いた空間としています。<br>本館は、これまでの２室を１室にし、平均客室面積を約３５㎡から約５０㎡へと拡大したスイートルームが中心となり、ベッドルームとリビングルームを分け、今まで以上にゆったりとおくつろぎいただける空間を実現しました。',
          button: {
            url: 'https://www.miyakohotels.ne.jp/westinkyoto/room/index.html',
          },
        },
        {
          title: 'クラブラウンジ<br>「Westin Club」',
          text:
            '東館 3 階に位置するクラブラウンジは、スイートルームにご宿泊のお客さまにご利用いただけます。朝食やカクテルタイムのメニューを充実させたほか、フリードリンクの種類も増やすなど、ラグジュアリーホテルにふさわしいおもてなしで、ゆったりとした安らぎの時間をお過ごしください。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/room/westinclub/index_1.html',
          },
        },
        {
          title: 'Westin WORKOUT™<br>フィットネススタジオ',
          text:
            'ジムエリアの面積を拡大し、新たな設備も導入しました。<br>ご宿泊のお客さまは、ジムエリアは 24 時間いつでもお好きなときに、屋内プール、ジャクジー、サウナは6：30〜21：00 まで無料で、ご利用いただけます。<br>また、かさばるスニーカーやフィットネスウェアをお持ちいただくことなく、普段通りのエクササイズをお楽しみいただけます。（レンタル用品は一部有料）',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/facilities/153099/index.html',
          },
        },
      ],
    },
    kasuien: {
      section_title: {
        headline: 'Renewal',
        title: '佳水園',
        num: '3',
      },
      contents: [
        {
          title:
            '自然の地形を活かした数寄屋風別館「佳水園」のぜいたくな空間で天然温泉とくつろぎの時間を',
          text:
            '村野藤吾氏の設計による、自然の地形を活かした高低変化に富む棟配置となっており、数寄屋風別館として多くのお客さまに親しまれてきました。今回のリニューアルでは、外観やパブリックスペースを承継しつつ、客室はこれまでの 2 室を 1 室にするなどし、平均客室面積を約 40 ㎡から約 70 ㎡へと拡大しました。<br>さらに、敷地内に湧出した天然温泉を各客室のお風呂に引き込み、客室内で天然温泉が楽しめるぜいたくなくつろぎの空間と、専属の「女将」が、細部まで心のこもったおもてなしをお届けいたします。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/lp/westinkyoto/kasuien/ja/index.html',
          },
        },
      ],
    },
    restaurant: {
      section_title: {
        headline: 'Renewal',
        title: 'レストラン',
        num: '4',
      },
      contents: [
        {
          title:
            'Dominique Bouchet Kyoto （ドミニク・ブシェ キョート）「Le RESTAURANT」',
          text:
            'フランス・パリと東京で活躍するフランス人シェフ、ドミニク・ブシェ氏の監修によるフレンチレストランでは、高級フレンチとともに、約300種類取りそろえたワインのなかから、ソムリエがお食事に最も合うワインをご提案いたします。<br>また、アペリティフのシャンパンや食後のチーズ・ブレッドを各ワゴンサービスにてきめ細やかに提供いたします。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/restaurant/153028/index.html',
          },
        },
        {
          title:
            'Dominique Bouchet Kyoto （ドミニク・ブシェ キョート） 「Le Teppanyaki」',
          text:
            'ドミニク・ブシェ氏が初めて監修する鉄板焼レストランは、フレンチらしい前菜に、京都産のお肉・神戸牛などのブランド牛をメインにしたお料理をお楽しみいただけます。魚介類、締めのお食事、デザートにもシェフのオリジナリティを添えます。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/restaurant/153030/index.html',
          },
        },
        {
          title: 'オールデイダイニング 「洛空 （らくう） 」',
          text:
            'コンセプトは「京の都」。<br>三条通に面した一面の大きな窓から外光が入り込む、天井が高く開放的なブッフェ形式のレストラン。<br>「五感で楽しむカウンター」をテーマとしたライブキッチンでは、西洋料理カウンターのほか、揚げたての天ぷらを楽しめる日本料理カウンター、約 20 種類以上のパンを焼き上げるベーカリーカウンター、パティシエがスイーツを仕上げる様子を間近でご覧いただけるデザートカウンターといった臨場感あふれる空間で、京都近郊の漁港から仕入れた魚介や京都産野菜をアレンジした料理など、多様な味覚をお楽しみいただけます。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/restaurant/152992/index.html',
          },
        },
        {
          title: 'ティーラウンジ「ＭＡＹＦＡＩＲ（メイフェア）」',
          text:
            '開放感のある空間でお楽しみいただけるのは、新進気鋭の英国発 高級紅茶ブランド「JING TEA（ジン ティー）」。ハイクオリティなスイーツとともに優雅なひとときをお過ごしいただけます。<br>テーマや素材にこだわったアフタヌーンティーをコーヒー・紅茶とともにお楽しみいただけ、高級フルーツを使用したケーキや自家製カステラ、和テイストのお菓子など、テイクアウト商品もご用意しています。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/mayfair/afternoontea/index.html',
          },
        },
        {
          title: 'バー「麓座 （ろくざ）」',
          text:
            '豊富な種類のシャンパンとピアノラウンジで生演奏をお楽しみいただけるバーです。<br>シャンパンラウンジではグランヴァンとヴィンテージを含む約 100 種類のシャンパンをご用意しています。<br>ピアノラウンジでは優美な空間でジャズの生演奏を美味しいお酒とともにお楽しみいただけます。また、京都らしさ、日本らしさを演出したお食事をはじめ、国産のジンやラムをベースにつくるカクテルは、海外からのお客さまにもお楽しみいただけます。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/bar/rokuza/index.html',
          },
        },
      ],
    },
    roof_garden: {
      section_title: {
        headline: 'Renewal',
        title: '屋上庭園',
        num: '5',
      },
      contents: [
        {
          title: '四季折々の移ろいを感じながら京都の街並みを一望できる屋上庭園',
          text:
            '西館屋上に新設した屋上庭園は、“The Queen of Eleganceが舞い降りた山麓の丘“をコンセプトに優美かつ曲線を活かしたデザインが特徴です。<br>四季折々の移ろいを感じることができる木々に囲まれた開放的な空間で京都の街並みを一望できる眺望も魅力です。',
          button: {
            url: '',
          },
        },
      ],
    },
    tanchoro: {
      section_title: {
        headline: 'Renewal',
        title: '探鳥路',
        num: '6',
      },
      contents: [
        {
          title: 'ホテル裏山の華頂山一帯で森林浴が楽しめる',
          text:
            '自然を身近に味わえ、多数の野鳥の生態に加え、春は桜、夏の蝉時雨、秋は紅葉、冬の森閑とした森の表情など四季折々をお楽しみいただけます。',
          button: {
            url: '',
          },
        },
      ],
    },
    chapel: {
      section_title: {
        headline: 'Renewal',
        title: 'チャペル',
        num: '7',
      },
      contents: [
        {
          title: 'Chapel「Grace」チャペル グレース',
          text:
            '今回のリニューアルで京都デザイン賞２０２０大賞を受賞したチャペル「Grace」は、ウェスティン都ホテル京都のウエディングにおいて、最も人気のある挙式会場です。<br>悠久の歴史とうつろう季節を見守り続けた華頂山の麓で、降り注ぐ太陽の光にあたたかく包まれながら、静かに佇む煉瓦造りの独立型チャペルです。',
          button: {
            url:
              'https://www.miyakohotels.ne.jp/westinkyoto/wedding/index.html',
          },
        },
      ],
    },
    banquet: {
      section_title: {
        headline: 'Renewal',
        title: 'バンケット',
        num: '8',
      },
      contents: [
        {
          title: '「グランビュー」「ムーンライト」',
          text:
            '2020 年 6 月に西館３階に新しく２つの新バンケットをオープンいたしました。<br>窓の外に見える自然の山並みと共存する「グランビュー」は、花をモチーフとしたカーペットは華やかな雰囲気を、天井の大小様々なパネルを使用したレイヤー感のあるデザインは自然の持つ重なりや奥行きを演出します。そのほか、パーティースペースとして 2 次会利用もできる「ムーンライト」もございます。',
          button: {
            url: '',
          },
        },
      ],
    },
  },
}
